import React, { Suspense, lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import Layout from 'src/ui/layout';
import { updateBodyClass } from 'src/helpers';
import { ADMIN_URL, BODY_CLASSES } from 'src/constants/constants.js';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';

//Lazy Load
const AdminContainer = lazy(() => import('src/ui/features/Admin/containers/AdminContainer'));

class AdminRoot extends React.Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.ADMIN);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.ADMIN);
  }

  render() {
    return (
      <Layout headerName={'Administration'}>
        <Suspense fallback={<ServiceSpinner open={true} />}>
          <Switch>
            <Route path={ADMIN_URL} render={props => <AdminContainer {...props} />} />
          </Switch>
        </Suspense>
      </Layout>
    );
  }
}

export default AdminRoot;
